import { FileText } from "lucide-react";

const FilePreview = ({ file }) => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();

  // PDF - Use your pdf_icon.png
  if (fileType === "application/pdf" || fileName.endsWith(".pdf")) {
    return (
      <div className="md:w-10 md:h-10 w-8 h-8 flex items-center justify-center bg-background-primary rounded-lg">
        <img src="/images/pdf_icon.png" alt="PDF" className="md:w-10 md:h-10 w-6 h-6" />
      </div>
    );
  }

  // DOC / DOCX
  return (
    <div className="md:w-10 md:h-10 w-8 h-8 flex items-center justify-center bg-background-primary rounded-lg">
      <FileText className="md:w-6 md:h-6 w-4 h-4 text-blue-400" />
    </div>
  );
};

export default FilePreview;
